import { startStimulusApp } from '@symfony/stimulus-bridge';
import AnalyticsController from './js/analytics-controller';
import BroadcastingV2IndexController from './js/broadcasting-v2-index-controller';
import BroadcastingV2ShowController from './js/broadcasting-v2-show-controller';
import ModalController from './js/modal-controller';

// Registers Stimulus controllers from controllers.json and in the controllers/ directory
const app = startStimulusApp(require.context(
    '@symfony/stimulus-bridge/lazy-controller-loader!./react',
    false,
    /\.[jt]sx?$/,
));
export default app;

app.register('analytics', AnalyticsController);
app.register('broadcasting-v2-index', BroadcastingV2IndexController);
app.register('broadcasting-v2-show', BroadcastingV2ShowController);
app.register('modal', ModalController);
